/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RedeemReward model module.
 * @module model/RedeemReward
 * @version v1
 */
class RedeemReward {
    /**
     * Constructs a new <code>RedeemReward</code>.
     * @alias module:model/RedeemReward
     * @param redeemSubject {String} MaxLength:500
     * @param redeemMessage {String} MaxLength:8000
     * @param displayQRCode {Boolean} 
     * @param redeemCode {String} MaxLength:8000
     */
    constructor(redeemSubject, redeemMessage, displayQRCode, redeemCode) { 
        
        RedeemReward.initialize(this, redeemSubject, redeemMessage, displayQRCode, redeemCode);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, redeemSubject, redeemMessage, displayQRCode, redeemCode) { 
        obj['RedeemSubject'] = redeemSubject;
        obj['RedeemMessage'] = redeemMessage;
        obj['DisplayQRCode'] = displayQRCode;
        obj['RedeemCode'] = redeemCode;
    }

    /**
     * Constructs a <code>RedeemReward</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RedeemReward} obj Optional instance to populate.
     * @return {module:model/RedeemReward} The populated <code>RedeemReward</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RedeemReward();

            if (data.hasOwnProperty('RedeemSubject')) {
                obj['RedeemSubject'] = ApiClient.convertToType(data['RedeemSubject'], 'String');
            }
            if (data.hasOwnProperty('RedeemMessage')) {
                obj['RedeemMessage'] = ApiClient.convertToType(data['RedeemMessage'], 'String');
            }
            if (data.hasOwnProperty('DisplayQRCode')) {
                obj['DisplayQRCode'] = ApiClient.convertToType(data['DisplayQRCode'], 'Boolean');
            }
            if (data.hasOwnProperty('RedeemCode')) {
                obj['RedeemCode'] = ApiClient.convertToType(data['RedeemCode'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RedeemReward</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RedeemReward</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of RedeemReward.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['RedeemSubject'] && !(typeof data['RedeemSubject'] === 'string' || data['RedeemSubject'] instanceof String)) {
            throw new Error("Expected the field `RedeemSubject` to be a primitive type in the JSON string but got " + data['RedeemSubject']);
        }
        // ensure the json data is a string
        if (data['RedeemMessage'] && !(typeof data['RedeemMessage'] === 'string' || data['RedeemMessage'] instanceof String)) {
            throw new Error("Expected the field `RedeemMessage` to be a primitive type in the JSON string but got " + data['RedeemMessage']);
        }
        // ensure the json data is a string
        if (data['RedeemCode'] && !(typeof data['RedeemCode'] === 'string' || data['RedeemCode'] instanceof String)) {
            throw new Error("Expected the field `RedeemCode` to be a primitive type in the JSON string but got " + data['RedeemCode']);
        }

        return true;
    }


}

RedeemReward.RequiredProperties = ["RedeemSubject", "RedeemMessage", "DisplayQRCode", "RedeemCode"];

/**
 * MaxLength:500
 * @member {String} RedeemSubject
 */
RedeemReward.prototype['RedeemSubject'] = undefined;

/**
 * MaxLength:8000
 * @member {String} RedeemMessage
 */
RedeemReward.prototype['RedeemMessage'] = undefined;

/**
 * @member {Boolean} DisplayQRCode
 */
RedeemReward.prototype['DisplayQRCode'] = undefined;

/**
 * MaxLength:8000
 * @member {String} RedeemCode
 */
RedeemReward.prototype['RedeemCode'] = undefined;






export default RedeemReward;

